module.exports = __webpack_public_path__ + "img/트라이던트.cdddca80.png";